/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MenuItemsDto as DigiworkMaitreDPosDtoMenuItemsMenuItemsDto } from '../../models/Digiwork/MaitreD/Pos/DTO/MenuItems/menu-items-dto';

export interface GetMenuItemsForMenuCategory$Params {
  menuCategoryId: string;
  isMenuItemRemoved?: boolean;
}

export function getMenuItemsForMenuCategory(http: HttpClient, rootUrl: string, params: GetMenuItemsForMenuCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoMenuItemsMenuItemsDto>> {
  const rb = new RequestBuilder(rootUrl, getMenuItemsForMenuCategory.PATH, 'get');
  if (params) {
    rb.path('menuCategoryId', params.menuCategoryId, {});
    rb.query('isMenuItemRemoved', params.isMenuItemRemoved, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoMenuItemsMenuItemsDto>;
    })
  );
}

getMenuItemsForMenuCategory.PATH = '/api/menu-categories/{menuCategoryId}/menu-items';
